<template>
  <v-card class="mx-auto" flat>
    <v-container>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Data Diri</h3>
        <base-form-generator :schema="dasar" v-model="form" />
      </div>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Kontak</h3>
        <base-form-generator :schema="kontak" v-model="form" />
      </div>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Pendidikan Terakhir</h3>
        <base-form-generator :schema="pendidikan" v-model="form" />
      </div>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Info Pendampingan</h3>
        <base-form-generator :schema="penugasan" v-model="form" />
      </div>
    </v-container>
  </v-card>
</template>

<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import SchemaBiodata from '../schema/biodata';

export default {
  name: 'FormBiodata',
  components: { BaseFormGenerator },
  mixins: [SchemaBiodata],
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      const profil = [...this.dasar, ...this.kontak, ...this.pendidikan, ...this.penugasan];
      for (const item of profil) {
        if (item.name) {
          this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
        }
      }

      this.$set(this.form, 'k_propinsi', this.$getDeepObj(value, 'k_propinsi') || '');
      this.$set(this.form, 'k_kota', this.$getDeepObj(value, 'k_kota') || '');
      this.$set(this.form, 'k_propinsi_ktp', this.$getDeepObj(value, 'k_propinsi_ktp') || '');
      this.$set(this.form, 'k_kota_ktp', this.$getDeepObj(value, 'k_kota_ktp') || '');
    },

    getValue() {
      return this.form;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped></style>
